module.exports = __webpack_public_path__ + "static/media/quan-logo.ca3ecb74.png";